/**
 * Session time as people read it: hours and minutes, never seconds.
 *
 *   formatHM(3900)  -> "1h 05m"
 *   formatHM(2700)  -> "45m"
 *   formatHM(0)     -> "0m"
 */
export function formatHM(seconds) {
  const total = Math.max(0, Math.floor((Number(seconds) || 0) / 60));
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (!h) return `${m}m`;
  return `${h}h ${String(m).padStart(2, "0")}m`;
}

/** "9:05 AM" for an ISO timestamp, in the browser's time zone. */
export function formatClock(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true }).toUpperCase();
}

/** Hours as a short number: 8 -> "8h", 7.5 -> "7.5h". */
export function formatHours(seconds) {
  const hours = Math.round(((Number(seconds) || 0) / 3600) * 10) / 10;
  return `${hours}h`;
}
